const url = '/bsp-data';
const Provider = 'BspData';
const dbModel = 'BspData';
const TABLE_NAME = 'bspdata';

export { url, Provider, dbModel, TABLE_NAME };
